import TopPlayedGames from "./TopPlayedGames";
export default TopPlayedGames